import React from 'react';
import QCXFormStepWizard from '../../shared-components/form-step-wizard/QCXFormStepWizard';
import QCXSelectOneModeloNumerarioTable from './QCXSelectOneModeloNumerarioTable';

export default function QCXSelectOneModeloNumerarioFinalFormTable({
  selected = null,
  isConsult,
  handleSubmit,
  handleChange,
  title,
  filterProp,
  columns,
  controlComponentProps,
  authInfo = {},
  requiredRoles = [],
  ...restProps
}) {
  return (
    <QCXFormStepWizard
      onSubmit={handleSubmit}
      controlComponentProps={controlComponentProps}
      authInfo={authInfo}
      requiredRoles={requiredRoles}
      {...restProps}
    >
      {() => (
        <QCXSelectOneModeloNumerarioTable
          title={title}
          columns={columns}
          filterProp={filterProp}
          selected={selected}
          isConsult={isConsult}
          handleChange={handleChange}
        />
      )}
    </QCXFormStepWizard>
  );
}
